import * as React from 'react'

interface Props {
  message?: string
}

export const MaintenanceOverlay: React.FC<Props> = ({ message }) => (
  <div className="tw-fixed tw-inset-0 tw-z-[99999] tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-white">
    <div className="tw-text-center tw-max-w-md tw-px-8">
      <h1 className="tw-text-3xl tw-font-bold tw-text-gray-800 tw-mb-4">Przerwa techniczna</h1>
      <p className="tw-text-gray-500 tw-text-base">
        {message || 'System jest chwilowo niedostępny. Prosimy spróbować za chwilę.'}
      </p>
    </div>
  </div>
)
